import React from "react";
import { useNavigate } from "react-router-dom";
import { MdWavingHand } from "react-icons/md";
import { GrLinkNext } from "react-icons/gr";
import { jwtDecode } from "jwt-decode";
import "./ProceedComponent.css";
import brandAsureLogo from "../assets/brand_assure_logo.svg";
import { landingRoute } from "../utils/auth"; // Assignee feature: role-based landing page

const SESSION_TIMEOUT_MS = 24 * 60 * 60 * 1000; // 24 hours

const ProceedComponent = () => {
  const navigate = useNavigate();

  const handleProceed = async () => {
    try {
      // 1️⃣ Get user details + access token from backend
      const response = await fetch("/mcv/user/details", {
        method: "GET",
        credentials: "include",
      });

      const result = await response.json();
      const data = result.detail || result; // handle "detail" wrapper in errors

      if (data.status !== "success") {
        alert(data.data || "An error occurred while proceeding.");
        navigate("/mcv/login");
        return;
      }

      let userDetails = data.user_details || [];
      const token = data.access_token;
      let roleFromToken = "";
      let promptProfile = "";

      if (token) {
        try {
          // 2️⃣ Validate token with backend
          const validateRes = await fetch("/mcv/validate_token", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ token }),
            credentials: "include",
          });

          const validateData = await validateRes.json();

          if (validateData.status !== "success" || !validateData.valid) {
            alert("Session invalid or expired. Please log in again.");
            navigate("/mcv/login");
            return;
          }

          // 3️⃣ Decode token locally (role comes from signed payload)
          const decoded = jwtDecode(token);
          console.log("Decoded token:", decoded);

          if (decoded?.user?.role) {
            roleFromToken = decoded.user.role;
            console.log("Role extracted from token:", roleFromToken);
          }
          if (decoded?.user?.prompt_profile) {
            promptProfile = decoded.user.prompt_profile;
            console.log("Prompt Profile extracted from token:", promptProfile);
          }
        } catch (err) {
          console.error("Token validation failed:", err);
          navigate("/mcv/login");
          return;
        }
      }

      // 4️⃣ Append role to user details only once
      if (Array.isArray(userDetails) && userDetails.length <= 6 && roleFromToken) {
        userDetails.push(roleFromToken);
      }

      // 5️⃣ Save user data + session timeout
      localStorage.setItem("userData", JSON.stringify(userDetails));
      localStorage.setItem("promptProfile", promptProfile);
      const expirationTime = Date.now() + SESSION_TIMEOUT_MS;
      localStorage.setItem("logoutExpiration", expirationTime.toString());

      console.log("User data saved to localStorage:", userDetails);
      console.log("Prompt Profile saved:", promptProfile);

    // 6️⃣ Navigate to dashboard or role-based landing page
      navigate(landingRoute());
    } catch (error) {
      console.error("Error during API call:", error);
      alert("An unexpected error occurred. Redirecting to login...");
      navigate("/mcv/login");
    }
  };

  return (
    <div className="proceed-container">
      <div className="proceed-page-header">
        <img
          src={brandAsureLogo}
          alt="BrandAssure"
          className="proceed-page-logo"
        />
      </div>

      <div className="proceed-content">
        <div className="proceed-header">
          <MdWavingHand className="welcome-icon" />
          <div className="proceed-component-header">
            Welcome to BrandAssure
          </div>
        </div>

        <p className="proceed-description">
          Your marketing content validator platform
        </p>

        <button className="proceed-button" onClick={handleProceed}>
          Proceed <GrLinkNext />
        </button>
      </div>
    </div>
  );
};

export default ProceedComponent;
